var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Error',{attrs:{"reload":true,"title":_vm.$t('com_error_404'),"description":_vm.$t('com_error_404_descriptoin')}},[_c('Icon',{attrs:{"type":"404"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }